import React from "react";
import HeroCarousel from "@/components/HeroCarousel";
import BandeauTrio from "@/components/BandeauTrio";
import About from "@/components/About";
import Highlights from "@/components/Highlights";
import Programs from "@/components/Programs";
import CampusWorld from "@/components/CampusWorld";
import Quiz from "@/components/Quiz";
import WhyChoose from "@/components/WhyChoose";
import EventsSection from "@/components/EventsSection";
import Admissions from "@/components/Admissions";
import TestimonialsSection from "@/components/TestimonialsSection";
import Enterprise from "@/components/Enterprise";
import PartnerLeadForm from "@/components/PartnerLeadForm";
import ContactSection from "@/components/ContactSection";
import AdmissionsFaq from "@/components/AdmissionsFaq";

export default function Home() {
  return (
    <>
      <HeroCarousel />
      <BandeauTrio />
      <Admissions />
      <About />
      <WhyChoose />
      <Quiz />
      <Highlights />
      <Programs />
      <TestimonialsSection />
      <EventsSection />
      <section id="partenaires-home" className="section-padding bg-white">
        <div className="container-edge max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <div className="overline mb-3">Entreprises & partenaires</div>
            <h2 className="font-display text-3xl md:text-5xl text-navy-700 leading-tight">
              Construisons <em className="not-italic red-shine">ensemble</em>.
            </h2>
          </div>
          <PartnerLeadForm />
        </div>
      </section>
      <AdmissionsFaq />
      <ContactSection />
      <CampusWorld />
    </>
  );
}
